import * as tslib_1 from "tslib";
import { sortArchivedThenByName } from '@core/utils/sort-archived-then-by-name';
import { EquipmentLinkService } from './services/equipment/equipment.service';
import { LocationLinkEnvironmentService } from './services/location-environment/location-environment.service';
import { LocationLinkSectorService } from './services/location-sector/location-sector.service';
import * as i0 from "@angular/core";
import * as i1 from "./services/location-sector/location-sector.service";
import * as i2 from "./services/equipment/equipment.service";
import * as i3 from "./services/location-environment/location-environment.service";
var LocationTabLinksService = /** @class */ (function () {
    function LocationTabLinksService(locationLinkSectorService, equipmentLinkService, locationLinkEnvironmentService) {
        this.locationLinkSectorService = locationLinkSectorService;
        this.equipmentLinkService = equipmentLinkService;
        this.locationLinkEnvironmentService = locationLinkEnvironmentService;
    }
    LocationTabLinksService.prototype.linkSectorsEnvironmentsEquipments = function (params) {
        var sectors = params.sectors, environments = params.environments, equipments = params.equipments;
        var environmentsBySectorMap = {};
        environments.forEach(function (environment) {
            environmentsBySectorMap[environment.locationSector.id] = environmentsBySectorMap[environment.locationSector.id] || [];
            environmentsBySectorMap[environment.locationSector.id].push(environment);
        });
        var unlinkedEquipments = [];
        var equipmentsBySectorMap = {};
        var equipmentsByEnvironmentMap = {};
        equipments.forEach(function (equipment) {
            if (equipment.locationSector) {
                if (equipment.locationEnvironment) {
                    equipmentsByEnvironmentMap[equipment.locationEnvironment.id] = equipmentsByEnvironmentMap[equipment.locationEnvironment.id] || [];
                    equipmentsByEnvironmentMap[equipment.locationEnvironment.id].push(equipment);
                }
                else {
                    equipmentsBySectorMap[equipment.locationSector.id] = equipmentsBySectorMap[equipment.locationSector.id] || [];
                    equipmentsBySectorMap[equipment.locationSector.id].push(equipment);
                }
            }
            else {
                unlinkedEquipments.push(equipment);
            }
        });
        sectors.sort(sortArchivedThenByName);
        sectors.forEach(function (sector) {
            sector.equipments = equipmentsBySectorMap[sector.id] || [];
            sector.equipments.sort(sortArchivedThenByName);
            Reflect.deleteProperty(equipmentsBySectorMap, sector.id);
            sector.locationEnvironments = environmentsBySectorMap[sector.id] || [];
            sector.locationEnvironments.sort(sortArchivedThenByName);
            sector.locationEnvironments.forEach(function (environment) {
                environment.equipments = equipmentsByEnvironmentMap[environment.id] || [];
                Reflect.deleteProperty(equipmentsByEnvironmentMap, environment.id);
                environment.equipments.sort(sortArchivedThenByName);
            });
        });
        Object.values(equipmentsBySectorMap).forEach(function (equipmentsWithNoSector) {
            unlinkedEquipments.push.apply(unlinkedEquipments, tslib_1.__spread(equipmentsWithNoSector));
        });
        Object.values(equipmentsByEnvironmentMap).forEach(function (equipmentsWithNoEnvironment) {
            unlinkedEquipments.push.apply(unlinkedEquipments, tslib_1.__spread(equipmentsWithNoEnvironment));
        });
        unlinkedEquipments.sort(sortArchivedThenByName);
        return {
            sectors: sectors,
            equipments: unlinkedEquipments
        };
    };
    LocationTabLinksService.prototype.formatSectors = function (sectors) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.locationLinkSectorService.formatSectors(sectors)];
            });
        });
    };
    LocationTabLinksService.prototype.formatUnlinkedEquipments = function (equipments) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.equipmentLinkService.formatUnlinkedEquipments(equipments)];
            });
        });
    };
    LocationTabLinksService.prototype.searchLocationSectors = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.locationLinkSectorService.searchLocationSectors({ where: params })];
            });
        });
    };
    LocationTabLinksService.prototype.searchEquipments = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.equipmentLinkService.searchEquipments({ where: params })];
            });
        });
    };
    LocationTabLinksService.prototype.searchEquipmentsWithWarranties = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.equipmentLinkService.searchEquipmentsWithWarranties({ where: params })];
            });
        });
    };
    LocationTabLinksService.prototype.searchLocationEnvironments = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.locationLinkEnvironmentService.searchLocationEnvironments({ where: params })];
            });
        });
    };
    LocationTabLinksService.prototype.searchLocationSectorsWithEnvironmentsAndEquipments = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.locationLinkSectorService.searchLocationSectorsWithEnvironmentsAndEquipments({ where: params })];
            });
        });
    };
    LocationTabLinksService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocationTabLinksService_Factory() { return new LocationTabLinksService(i0.ɵɵinject(i1.LocationLinkSectorService), i0.ɵɵinject(i2.EquipmentLinkService), i0.ɵɵinject(i3.LocationLinkEnvironmentService)); }, token: LocationTabLinksService, providedIn: "root" });
    return LocationTabLinksService;
}());
export { LocationTabLinksService };
